export default __webpack_public_path__ + "static/media/the_pulse_tile_cover.c25cee8d.jpg";